import { defineStore } from 'pinia';

// Whether Algolia served this search from the blended variant index. The filter components read it
// to stop treating spare rooms as an exclusive mode; result cards read their own payload instead.
export const useSearchModeStore = defineStore('searchMode', {
  state: () => ({
    blendedSearch: false,
  }),

  actions: {
    setBlendedSearch(value) {
      this.blendedSearch = !!value;
    },
  },
});
